import { useEffect } from "react";
import Footer from "./Footer";
import Header from "./Header";
import EnterpriseHeader from "../../components/ui/enterprise1/EnterpriseHeader";
import EnterpriseFooter from "../../components/ui/enterprise1/EnterpriseFooter";

const Layout = ({ children, title = "React App", variant }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
  const isEnterprise = variant === "enterprise";
  return (
    <main className="relative">
      {isEnterprise ? <EnterpriseHeader variant={title} /> : <Header />}
      {children}
      {isEnterprise ? <EnterpriseFooter /> : <Footer />}
    </main>
  );
};

export default Layout;
